import React, { useState, useImperativeHandle, useEffect, forwardRef } from 'react'
import Api from '../../../../../../_helpers/Api'

//images
import docIcon from '../../../../../../assets/img/icons/document.png'
import closeIcon from '../../../../../../assets/img/icons/close.png'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"
import loader from '../../../../../../assets/img/loader.svg'
import deleteIcon from '../../../../../../assets/img/icons/delete-red.png'
import { trans } from '../../../../../../_providers/Translation'
import Skeleton from "react-loading-skeleton"

function ReservationStatus(props, ref) {

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        id: null,
        data: {
            color: '#cccccc',
            text_color: '#ffffff'
        },
        loading: false,
        update: false,
        onSave: null
    })

    const [icons, setIcons] = useState([])
    const [selectedIconId, setSelectedIconId] = useState(null)

    const [loadingIcons, setLoadingIcons] = useState(false)

    const [validations, setValidations] = useState(null)

    useImperativeHandle(ref, () => ({
        open: () => {
            handleShow()
        },
        edit: id => {
            setPopup(prev => ({
                ...prev,
                id: id,
                update: new Date().getTime()
            }))
            handleShow()
        },
        hide: () => {
            handleHide()
        },
        onSave: fn => {
            setPopup(prev => ({
                ...prev,
                onSave: fn
            }))
        }
    }))

    useEffect(() => {
        if (popup.overlay) {
            setLoadingIcons(true)
            Api.get('reservation-status-icons')
                .then(res => {
                    setIcons(res.data)

                })
                .finally(() => {
                    setLoadingIcons(false)
                })
        }
    }, [popup.overlay])

    useEffect(() => {
        if (popup.id) {
            Api.get('reservations/statuses/find?id=' + popup.id)
                .then(res => {
                    let data = res.data

                    data.name = res?.data?.translation?.name

                    setPopup(prev => ({
                        ...prev,
                        data: data
                    }))

                    if (res.data?.icon?.id) {
                        setSelectedIconId(res.data?.icon?.id)
                    }
                })
        }
    }, [popup.update])

    const handleShow = () => {
        setPopup(prev => ({
            ...prev,
            overlay: true
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }))
        }, 50)
    }

    const handleHide = e => {
        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            modal: false,
            loading: false,
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false,
                id: null,
                data: {}
            }))
            setSelectedIconId(null)
        }, 50)
    }

    const handleSave = e => {
        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            loading: true,
        }))

        setValidations(null)

        let url = 'reservations/statuses/' + (popup.id ? 'edit' : 'add')

        let data = new FormData(e.target)

        if (popup.id) {
            data.append('id', popup.id)
        }

        Api.post(url, data)
            .then(res => {

                handleHide(e)

                if (typeof popup.onSave === 'function') {
                    popup.onSave(res.data)
                }

            }).catch(error => {

                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }))

                let _err = error.response

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {

                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        })
                    }
                }

            })
    }


    const handleInputChange = (e) => {
        let name = e.target.name
        let val = e.target.value

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }))
    }


    return (
        <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
            <form className={`${popup.modal ? 'show' : ''} popup-primary large`} onSubmit={handleSave}>
                <div className='head-new'>
                    <img src={popupDefaultHeadImage} alt="icon" />
                    <div className='texts'>
                        <h2>
                            {popup.id ? trans('headings.editReservationStatus') : trans('headings.addReservationStatus')}
                        </h2>
                        <p>
                            {trans('subheadings.editReservationStatus')}
                        </p>
                    </div>
                    <span className='close' onClick={handleHide}>

                    </span>
                </div>

                <div className="row">
                    <div className="col">
                        <label>
                            {trans('labels.name')}
                        </label>
                        <input
                            type="text"
                            name="name"
                            className={validations && validations.name ? 'validate' : ''}
                            value={popup.data.name ? popup.data.name : ''}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="col">
                        <label>
                            {trans('labels.type')}
                        </label>
                        <select
                            name="type_id"
                            className={validations && validations.type_id ? 'validate' : ''}
                            value={popup.data.type_id ? popup.data.type_id : ''}
                            onChange={handleInputChange}
                        >
                            <option value={''}>

                            </option>
                            <option value={1}>
                                {trans('labels.initialStatus')}
                            </option>
                            <option value={2}>
                                {trans('labels.finalStatus')}
                            </option>
                        </select>
                    </div>
                </div>

                <div className="row">
                    <div className="col" style={{ width: 'auto' }}>
                        <label>
                            {trans('labels.color')}
                        </label>
                        <input
                            type="color"
                            name="color"
                            className={validations && validations.color ? 'validate' : ''}
                            value={popup.data.color ? popup.data.color : ''}
                            onChange={handleInputChange}
                            style={{
                                border: "none",
                                padding: 0,
                            }}
                        />
                    </div>

                    <div className="col" style={{ width: 'auto' }}>
                        <label>
                            {trans('labels.textColor')}
                        </label>
                        <input
                            type="color"
                            name="text_color"
                            className={validations && validations.text_color ? 'validate' : ''}
                            value={popup.data.text_color ? popup.data.text_color : ''}
                            onChange={handleInputChange}
                            style={{
                                border: "none",
                                padding: 0,
                            }}
                        />
                    </div>

                    <div className="col" style={{ width: 'auto' }}>
                        <label>
                            {trans('labels.preview')}
                        </label>
                        <span
                            style={{
                                background: popup.data.color || "#20587bff",
                                color: popup.data.text_color || "#fff",
                                padding: "3px 7px",
                                fontSize: "14px",
                                borderRadius: 4,
                            }}
                        >
                            0123456789
                        </span>
                    </div>
                </div>
                <div className="row">
                    <div className="col">

                        <label>
                            {trans('labels.selectIcon')}
                        </label>
                        <input type="hidden" name="icon_id" value={selectedIconId || ''} />
                        {loadingIcons ?
                            <Skeleton height={140} count={1} />
                            :
                            <>
                                <div className={`icon-picker ${validations && validations.icon_id ? 'validate' : ''}`}>
                                    {icons.map(icon => (
                                        <button
                                            key={icon.id}
                                            type="button"
                                            title={icon.label}
                                            className={`icon-picker-item${selectedIconId === icon.id ? ' selected' : ''}`}
                                            onClick={() => setSelectedIconId(icon.id)}
                                        >
                                            <img src={icon.url} alt={icon.label} />
                                        </button>
                                    ))}
                                </div>
                            </>
                        }

                    </div>
                </div>

                <div className="footer align-right">
                    {popup.loading ?
                        <img src={loader} alt="loading" />
                        :
                        <>
                            <button className="button" onClick={handleHide}>
                                {trans('buttons.cancel')}
                            </button>
                            <button className="button button-primary" type="submit">
                                {trans('buttons.save')}
                            </button>
                        </>
                    }
                </div>
            </form >
        </div >
    )
}

export default forwardRef(ReservationStatus)